import { css } from '@emotion/core';

export const errorStyleOverrides = css`
  padding-left: 37px;
`;
